import React, { useContext } from 'react';
import { IAppProps } from '../App';

export const ActiveAdsContext = React.createContext<IAppProps>({} as IAppProps);

export const useActiveAds = () => useContext(ActiveAdsContext);